module.exports = require("firebase-admin");